import type { ReactNode } from "react";

export function SectionHead({
  eyebrow,
  title,
  action,
}: {
  eyebrow?: string;
  title: string;
  action?: ReactNode;
}) {
  return (
    <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", gap: 16, marginBottom: 16 }}>
      <div>
        {eyebrow && (
          <div
            style={{
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: 0.8,
              textTransform: "uppercase",
              color: "var(--accent)",
              marginBottom: 6,
            }}
          >
            {eyebrow}
          </div>
        )}
        <h2 style={{ margin: 0, fontFamily: "var(--display)", fontSize: 28, fontWeight: 400, letterSpacing: -0.8 }}>
          {title}
        </h2>
      </div>
      {action}
    </div>
  );
}
